import { Checkbox, Group, NumberInput, Text } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { useTranslation } from "react-i18next"
import { CalendarProfileFormValues } from "./CalendarProfileForm"

export function PersonalCalendarFields({
  form,
}: {
  form: UseFormReturnType<CalendarProfileFormValues>
}) {
  const { t } = useTranslation("app_server")
  return (
    <>
      <Text size="sm">{t("AppointmentTypes")}</Text>
      <Text size="xs" c="dimmed">
        {t("Calendar_Subscriptions_AppointmentTypesDescription")}
      </Text>
      <Group>
        <Checkbox
          label={t("Absences")}
          {...form.getInputProps(
            "personalSettings.includeAbsenceAppointments",
            { type: "checkbox" }
          )}
        />
        <Checkbox
          label={t("Casts")}
          {...form.getInputProps("personalSettings.includeCastAppointments", {
            type: "checkbox",
          })}
        />
        <Checkbox
          label={t("PossibleCast")}
          {...form.getInputProps(
            "personalSettings.includePossibleCastAppointments",
            { type: "checkbox" }
          )}
        />
        <Checkbox
          label={t("DutyRosters")}
          {...form.getInputProps(
            "personalSettings.includeDutyRosterAppointments",
            { type: "checkbox" }
          )}
        />
        <Checkbox
          label={t("Travels")}
          {...form.getInputProps("personalSettings.includeTravelAppointments", {
            type: "checkbox",
          })}
        />
      </Group>
      <Group>
        <NumberInput
          min={0}
          allowDecimal={false}
          label={t("NumberOfDaysInThePast")}
          {...form.getInputProps("personalSettings.daysOffsetInPast")}
        />
        <NumberInput
          min={0}
          allowDecimal={false}
          label={t("NumberOfDaysInTheFuture")}
          {...form.getInputProps("personalSettings.daysOffsetInFuture")}
        />
      </Group>
    </>
  )
}
